import React from 'react';
import * as queryString from 'qs';
import NewAccountPanel from './NewAccountPanel';
import UploadSuccessPanel from './UploadSuccessPanel';


const ZeroStateModalNewAccountBody = () => {
  const queryParams = queryString.parse(window.location.search, { ignoreQueryPrefix: true });
  const { documentType, document_name: documentName } = queryParams;

  return (
    <div className="self-serve-zero-state-modal-new-account-form-body">
      <NewAccountPanel
        documentType={documentType}
      />
      <div className="divider" />
      <UploadSuccessPanel
        documentName={documentName}
      />
    </div>
  );
};

export default ZeroStateModalNewAccountBody;



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/ZeroStateModal/ZeroStateModalNewAccountBody/index.jsx